import axios from "axios";

const axiosInstance = axios.create({
	withCredentials: true,
});

const isAxiosError = axios.isAxiosError;

export {axiosInstance, isAxiosError};
